var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.291 2.85835C13.5448 2.60451 13.9564 2.60451 14.2102 2.85835L17.9602 6.60835C18.214 6.86219 18.214 7.27375 17.9602 7.52759L14.2102 11.2776C13.9564 11.5314 13.5448 11.5314 13.291 11.2776C13.0371 11.0237 13.0371 10.6122 13.291 10.3583L16.5813 7.06797L13.291 3.77759C13.0371 3.52375 13.0371 3.11219 13.291 2.85835Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8751 7.71797C5.88717 7.71797 4.9397 8.11042 4.24112 8.809C3.54255 9.50757 3.1501 10.455 3.1501 11.443C3.1501 12.4309 3.54255 13.3784 4.24112 14.0769C4.9397 14.7755 5.88717 15.168 6.8751 15.168H13.7501C14.1091 15.168 14.4001 15.459 14.4001 15.818C14.4001 16.177 14.1091 16.468 13.7501 16.468H6.8751C5.54238 16.468 4.26426 15.9385 3.32189 14.9962C2.37952 14.0538 1.8501 12.7757 1.8501 11.443C1.8501 10.1103 2.37952 8.83213 3.32189 7.88976C4.26426 6.94739 5.54238 6.41797 6.8751 6.41797H17.5001C17.8591 6.41797 18.1501 6.70898 18.1501 7.06797C18.1501 7.42695 17.8591 7.71797 17.5001 7.71797H6.8751Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.3b732ee9ab557e9ce59a6f4359331355.svg";
export { ForwardRef as ReactComponent };